import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const notificationPreferencesNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("notification-management", "Notification Preferences"),
  pageNameForTracking: () => "Notification Preferences",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
